import { gql } from '@apollo/client';
import { LightPersonProfileFragment } from '../person/LightPersonProfile';

export enum ApiKeyState {
  Active = 'ACTIVE',
  Revoqued = 'REVOKED'
}

export const ApiKeyFragment = gql`
  fragment ApiKey on ApiKey {
    uuid
    name
    state
    creator {
      ...LightPersonProfile
    }
    creationDate
    revocationDate
    accessRights {
      label
      groupCode
      accountName
      accountCode
    }
  }
  ${LightPersonProfileFragment}
`;
